import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { toast } from "react-toastify";
import billerHttp from "../../../utils/billerHttp";

type Payload = {
  providerId: string;
}

export const usePostProviderBillerList = () => {
  const queryClient = useQueryClient();

  const { mutate, data, variables, reset, ...rest } = useMutation({
    mutationKey: ['add providers biller list'],
    mutationFn: async ({ providerId }: Payload) => {
      const response = await billerHttp.post('billers/provider', {
        providerId
      })
      return response.data;
    },

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['get all biller providers'] as const
      });
      toast.success("Provider added");
    },

    onError: (error) => {
      if (axios.isAxiosError(error)) {
        toast.error(
          error?.response?.data?.error || error.response?.statusText,
        );
      } else {
        toast.error(
          error?.message
          || "Error adding provider, try again or contact admin",
        );
      }
    },
  });

  return {
    addProviderToBillersList: mutate,
    variables,
    ...rest,
  };
}
